import Swal from "sweetalert2";
import '../styles/Alertas.css';

// Helper para asegurar que los modales de SweetAlert siempre aparezcan por encima
const ensureSwalZIndex = () => {
    try {
        if (typeof document === 'undefined') return;
        const existingStyle = document.getElementById('swal-zfix-style');
        if (!existingStyle) {
            const style = document.createElement('style');
            style.id = 'swal-zfix-style';
            style.textContent = `
                .swal2-container { z-index: 2147483647 !important; }
            `;
            document.head.appendChild(style);
        }
    } catch (_e) {
        // Ignorar errores no críticos del DOM
    }
};

export function alertaGeneral({ titulo, messageHtml, confirmButtonText = "Aceptar", cancelButton = false, cancelButtonText = '', isError = false, isWarning = false, isInfo = false }) {
    ensureSwalZIndex();
    try { Swal.close(); } catch (_e) { /* ignore */ }

    return Swal.fire({
        title: titulo,
        html: messageHtml,
        icon: isError ? 'error' : isWarning ? 'warning' : isInfo ? 'info' : 'success',
        confirmButtonText,
        showCancelButton: cancelButton,
        cancelButtonText: cancelButtonText,
        focusCancel: true,
        customClass: {
            popup: 'swal-custom-popup',
            title: 'swal-custom-title',
            htmlContainer: 'swal-custom-html',
            confirmButton: 'swal-custom-button',
            cancelButton: 'swal-custom-cancel-button',
            icon: 'swal-custom-icon'
        },
        backdrop: 'rgba(0, 0, 0, 0.2)',
        heightAuto: false,
        target: document.body,
        scrollbarPadding: false,
        allowOutsideClick: true,
        allowEscapeKey: true,
    });
}

// Confirmación bonita e instantánea (sin animación)
export function alertaConfirmacion({
    titulo,
    messageHtml,
    confirmButtonText = 'Confirmar',
    cancelButtonText = 'Cancelar',
    icon = 'warning'
}) {
    ensureSwalZIndex();
    try {
        Swal.close();
    } catch (_e) {
        // Ignorar
    }

    return Swal.fire({
        title: titulo,
        html: messageHtml,
        icon,
        showCancelButton: true,
        confirmButtonText,
        cancelButtonText,
        reverseButtons: true,
        focusCancel: true,
        heightAuto: false,
        target: document.body,
        scrollbarPadding: false,
        allowOutsideClick: true,
        allowEscapeKey: true,
        animation: false, // clave: aparece instantáneo
        backdrop: 'rgba(15, 23, 42, 0.45)', // más notorio, sin “pantalla blanca”
        customClass: {
            popup: 'swal-confirm-popup',
            title: 'swal-confirm-title',
            htmlContainer: 'swal-confirm-html',
            confirmButton: 'swal-confirm-button',
            cancelButton: 'swal-confirm-cancel-button',
            icon: 'swal-confirm-icon'
        }
    });
}

export function alertaToastTopEnd({ mensaje, isError = false }) {
    Swal.fire({
        toast: true,
        position: 'top-end',
        icon: isError ? 'error' : 'success',
        title: mensaje,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        width: '400px',
        padding: '1rem',
        background: '#fff',
        customClass: {
            popup: 'swal-toast-popup',
            title: 'swal-toast-title',
            icon: 'swal-toast-icon'
        }
    });
}

/* Esta alerta es para que no deje hacer "nada" y de un mensaje de que se está realizando el proceso */
export function alertaCargandoProceso({ titulo, messageHtml, funcionAsync, isTransparent }) {
    Swal.fire({
        title: titulo,
        html: messageHtml,
        allowOutsideClick: false,
        allowEscapeKey: false,
        // allowEnterKey: false,
        background: isTransparent ? 'transparent' : undefined,
        timerProgressBar: true,
        didOpen: () => {
            Swal.showLoading();
            // Inicia la operación del servidor
            funcionAsync(); //La funcion debe manejar el cierre de la alerta con Swal.close()
        }
    });
}